import { render, staticRenderFns } from "./SourceMetaDataTable.vue?vue&type=template&id=6644b4b0&"
import script from "./SourceMetaDataTable.vue?vue&type=script&lang=js&"
export * from "./SourceMetaDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports